import React from "react";
import {
  ComponentProjectListRequestPageContent,
  ComponentProjectListRequestPageStateProvider,
} from ".";
import { DeploymentRequestInfomationInputDialogStateProvider } from "../dialog/deployment-request-infomation-input-dialog";

export const ComponentProjectListRequestPage = () => {
  return (
    <>
      <ComponentProjectListRequestPageStateProvider>
        <DeploymentRequestInfomationInputDialogStateProvider>
          <ComponentProjectListRequestPageContent />
        </DeploymentRequestInfomationInputDialogStateProvider>
      </ComponentProjectListRequestPageStateProvider>
    </>
  );
};
